module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "data": _vm.saves
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usedFor",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'save',
                params: {
                  saveName: scope.row.name
                }
              })
            }
          }
        }, [_vm._v("Info")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "disabled": !!scope.row.usedFor
          },
          on: {
            "click": function($event) {
              _vm.removeSave(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }]
    ])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-34dc6f3e"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/save/Index.vue
// module id = 158
// module chunks = 1